import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { authSlice } from './auth/authSlice'
import { permissionSlice } from './permission/permissionSlice'

const store = configureStore({
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false
    }),
    reducer: {
        auth: authSlice.reducer,
        permission: permissionSlice.reducer
    }
})

export {
    store
}